<template>
  <div class="halaman-admin">
    <div class="dashboard-container">
      <div
        v-if="loading"
        class="progress-bar"
        :style="{ width: progress + '%' }"
      ></div>

      <div class="mb-2 page-title">
        <i class="bi bi-trophy"></i> Daftar Turnamen
      </div>

      <div class="mb-2 d-flex justify-content-between align-items-center">
        <!-- Search Bar -->
        <DataToolbar
          v-model="searchQuery"
          placeholder="Cari..."
          :mencari="loading"
          @search="searchTournament"
        />

        <!-- Create Menu Button (Hanya Super Admin) -->
        <router-link v-if="isSuperAdmin" to="/admin/tournament/create" class="button button-primary">
          <i class="bi bi-plus-square"></i> Tambah Turnamen
        </router-link>
      </div>

      <!-- Table to display navigation data -->
      <div class="table-responsive mt-3">
        <table class="table mb-0">
          <thead>
            <tr>
              <th class="number-column">#</th>
              <th>Nama Turnamen</th>
              <th>Rapat Teknis</th>
              <th>Mulai</th>
              <th>Selesai</th>
              <th>Status</th>
              <th>Aksi</th>
            </tr>
          </thead>
          <tbody v-if="tournaments.length > 0">
            <tr v-for="(tournament, index) in tournaments" :key="tournament.id">
            <td>{{ index + 1 + (currentPage - 1) * perPage }}</td>
         
              <td>{{ tournament.name }}</td>
              <td class="nowrap">{{ tanggalRingkas(tournament.technical_meeting_date) }}</td>
              <td class="nowrap">{{ tanggalRingkas(tournament.start_date) }}</td>
              <td class="nowrap">{{ tanggalRingkas(tournament.end_date) }}</td>
              <td>
                <span class="lencana" :class="`lencana--${kelasStatus(tournament)}`">
                  {{ labelStatus(tournament) }}
                </span>
              </td>
              <td class="action-column">
                <div class="d-flex gap-2 justify-content-end">
          <MenuAksi v-slot="{ tutup }">
            <button v-if="isSuperAdmin" type="button" class="aksi__item"
                    @click="tutup(); $router.push({ name: 'PenggunaEvent', params: { id: tournament.id } })">
              <i class="bi bi-people"></i> Admin &amp; Bendahara
            </button>
            <button type="button" class="aksi__item"
                    @click="tutup(); $router.push({ path: '/admin/keuangan', query: { tournament_id: tournament.id } })">
              <i class="bi bi-cash-coin"></i> Keuangan
            </button>
            <button type="button" class="aksi__item"
                    @click="tutup(); $router.push({ path: '/admin/id-card', query: { tournament_id: tournament.id } })">
              <i class="bi bi-person-badge"></i> Cetak ID Card Massal
            </button>
            <button type="button" class="aksi__item"
                    @click="tutup(); EditTournament(tournament.id)">
              <i class="bi bi-pencil-square"></i> Ubah
            </button>
            <button v-if="isSuperAdmin" type="button" class="aksi__item aksi__item--bahaya"
                    @click="tutup(); hapusTurnamen(tournament)">
              <i class="bi bi-trash"></i> Hapus
            </button>
          </MenuAksi>
        </div>
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td colspan="7" class="text-center py-4 text-muted">Belum ada turnamen.</td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Pagination Controls -->
      <div class="d-flex justify-content-end mt-4">
        <AppPagination
          :current-page="currentPage"
          :total-pages="totalPages"
          :prev-page-url="prevPageUrl"
          :next-page-url="nextPageUrl"
          @change-page="changePage"
        />
      </div>
    </div>
  </div>
</template>

<script>
import http from "@/services/http";
import MenuAksi from "@/components/ui/MenuAksi.vue";
import AppPagination from "@/components/ui/AppPagination.vue";
import { useConfirm } from "@/composables/useConfirm";
import { useToast } from "vue-toastification";
import { inject } from 'vue';
import DataToolbar from "@/components/ui/DataToolbar.vue";
import { normalkanStatus, STATUS } from "@/utils/status";

export default {
  name: "TournamentList",

  components: { MenuAksi, DataToolbar, AppPagination },
  data() {
    return {
      tournaments: [],
      searchQuery: "", // User's search input
      currentPage: 1, // Current page of results
      perPage: 10, // Results per page
      totalPages: 0, // Total number of pages
      prevPageUrl: null, // URL of the previous page
      nextPageUrl: null, // URL of the next page
      loading: false,
      progress: 0,
    };
  },

  setup() {
    const toast = useToast();
    const permissions = inject('permissions', []); // Ensure permissions is always an array
    const { konfirmasi } = useConfirm();

    return { toast, permissions, konfirmasi };
  },
  mounted() {
    this.loadTournament();
  },
  methods: {
    /** "2026-08-17T17:00:00.000000Z" -> "17 Agu 2026" */
    tanggalRingkas(nilai) {
      if (!nilai) return '—';
      const d = new Date(nilai);
      if (Number.isNaN(d.getTime())) return nilai;
      return d.toLocaleDateString('id-ID', { day: 'numeric', month: 'short', year: 'numeric' });
    },

    /** Status mentah -> istilah yang dipakai di formulir. */
    labelStatus(turnamen) {
      return {
        [STATUS.DIBUKA]: 'Dibuka',
        [STATUS.SEGERA]: 'Segera hadir',
        [STATUS.DITUTUP]: 'Pendaftaran ditutup',
        [STATUS.SELESAI]: 'Selesai',
        [STATUS.SEMBUNYIKAN]: 'Disembunyikan',
      }[normalkanStatus(turnamen.status_normal || turnamen.status)] || '—';
    },

    /** Status mentah -> warna lencana. */
    kelasStatus(turnamen) {
      return {
        [STATUS.DIBUKA]: 'hijau',
        [STATUS.SEGERA]: 'kuning',
        [STATUS.DITUTUP]: 'kuning',
        [STATUS.SELESAI]: 'netral',
        [STATUS.SEMBUNYIKAN]: 'redup',
      }[normalkanStatus(turnamen.status_normal || turnamen.status)] || 'netral';
    },

    
    async loadTournament(page = 1) {
      this.loading = true;
      try {
        // /tournament-settings khusus super admin. Admin event memakai
        // /tournaments, yang di server sudah tersaring ke kejuaraannya.
        const alamat = this.isSuperAdmin ? "/tournament-settings" : "/tournaments";
        const response = await http.get(alamat, {
          params: {
            page,
            perPage: this.perPage,
            search: this.searchQuery.trim(),
          },
        });
        const {
          current_page,
          last_page,
          data,
          next_page_url,
          prev_page_url,
        } = response.data;

        this.tournaments = data;
        this.currentPage = current_page;
        this.totalPages = last_page;
        this.nextPageUrl = next_page_url;
        this.prevPageUrl = prev_page_url;
      } catch (error) {
        this.toast.error(error.friendlyMessage || "Gagal memuat daftar turnamen.");
      } finally {
        this.loading = false;
      }
    },

    changePage(page) {
      if (page >= 1 && page <= this.totalPages) {
        this.loadTournament(page);
      }
    },

    searchTournament(teks) {
      if (typeof teks === "string") this.searchQuery = teks;
      this.currentPage = 1;
      this.loadTournament();
    },

    EditTournament(id) {
      this.$router.push({ name: "EditTournament", params: { id } });
    },

    async hapusTurnamen(turnamen) {
      const setuju = await this.konfirmasi({
        title: "Hapus turnamen?",
        message: "Data kejuaraan ini ikut terhapus dan tidak bisa dikembalikan.",
        itemName: turnamen.name,
      });
      if (!setuju) return;

      try {
        await http.delete(`/tournament-settings/${turnamen.id}`);
        this.toast.success("Turnamen dihapus.");
        this.loadTournament();
      } catch (error) {
        this.toast.error(error.friendlyMessage || "Gagal menghapus turnamen.");
      }
    },
  },
  computed: {
    isSuperAdmin() {
      try {
        const user = JSON.parse(localStorage.getItem('user') || '{}');
        return user.group?.name === 'Owner';
      } catch (e) {
        return false;
      }
    },
    prevPageExists() {
      return this.currentPage > 1;
    },
    nextPageExists() {
      return this.currentPage < this.totalPages;
    },
  },
};
</script>

<style scoped>
.nowrap { white-space: nowrap; }

/* Lencana status turnamen */
.lencana {
  display: inline-flex;
  align-items: center;
  gap: var(--space-1);
  padding: 3px var(--space-3);
  font-size: var(--text-xs);
  font-weight: 700;
  white-space: nowrap;
  border-radius: var(--radius-full);
  border: 1px solid transparent;
}

.lencana--hijau  { color: var(--success-600); background: rgb(22 163 74 / 0.12); border-color: rgb(22 163 74 / 0.30); }
.lencana--kuning { color: var(--text-brand);  background: var(--accent-subtle); border-color: var(--flame-200); }
.lencana--netral { color: var(--text-secondary); background: var(--bg-sunken); border-color: var(--border-subtle); }
/* "Disembunyikan" sengaja dibuat paling pudar: statusnya bukan pencapaian,
   melainkan penanda bahwa turnamen ini tidak terlihat siapa pun. */
.lencana--redup  { color: var(--text-muted); background: transparent; border-style: dashed; border-color: var(--border-strong); }


.table th,
.table td {
  padding: 10px;
}




input::placeholder {
    color: var(--text-muted);
    font-size: 15px;  /* Change font size */
    font-style: italic;  /* Change font style */
    opacity: 1;  /* Full opacity (default is 0.5) */
    font-family: 'Figtree', sans-serif;
}




.form-control {
  width: 250px;
}

.progress-bar {
  position: absolute;
  top: 0;
  left: 0;
  height: 5px;
  background: var(--grad-flame);
  animation: loader-animation 1.5s infinite;
}

/* Animasi garis loader */
@keyframes loader-animation {
  0% {
    width: 0;
    background: var(--grad-flame); /* Warna awal */
  }
  50% {
    width: 50%;
    background: var(--grad-flame); /* Warna saat animasi */
  }
  100% {
    width: 100%;
    background: var(--grad-flame);
  }
}
</style>
